export interface Deal {
  id: string;
  title: string;
  client_name: string;
  client_contact: string;
  client_email: string;
  client_phone: string;
  event_type: string;
  event_date: string | null;
  event_location: string;
  guest_count: number | null;
  status: DealStatus;
  priority: DealPriority;
  estimated_budget: number | null;
  currency: string;
  notes: string;
  position: number;
  chat_session: number | null;
  chat_session_id: string | null;
  created_by: string | null;
  created_by_email: string | null;
  assigned_to: string | null;
  assigned_to_email: string | null;
  created_at: string;
  updated_at: string;
}

export type DealStatus = 'lead' | 'contacted' | 'proposal' | 'negotiating' | 'won' | 'lost';
export type DealPriority = 'low' | 'medium' | 'high';
export type DealViewMode = 'kanban' | 'list' | 'calendar';

export const DEAL_STATUS_LABELS: Record<DealStatus, string> = {
  lead: 'Lead',
  contacted: 'Contacted',
  proposal: 'Proposal',
  negotiating: 'Negotiating',
  won: 'Won',
  lost: 'Lost',
};

export const DEAL_STATUS_COLORS: Record<DealStatus, string> = {
  lead: 'var(--color-info)',
  contacted: 'var(--color-primary)',
  proposal: 'var(--color-warning)',
  negotiating: 'var(--color-accent)',
  won: 'var(--color-success)',
  lost: 'var(--color-danger)',
};

export const DEAL_STATUS_ORDER: DealStatus[] = [
  'lead',
  'contacted',
  'proposal',
  'negotiating',
  'won',
  'lost',
];

export const DEAL_PRIORITY_LABELS: Record<DealPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};

export interface DealFilters {
  status?: DealStatus;
  priority?: DealPriority;
  assigned_to?: string;
  search?: string;
}

export interface CreateDealData {
  title: string;
  client_name: string;
  client_contact?: string;
  client_email?: string;
  client_phone?: string;
  event_type?: string;
  event_date?: string | null;
  event_location?: string;
  guest_count?: number | null;
  status?: DealStatus;
  priority?: DealPriority;
  estimated_budget?: number | null;
  currency?: string;
  notes?: string;
  assigned_to?: string | null;
}

export interface UpdateDealData extends Partial<CreateDealData> {
  position?: number;
}

export interface MoveDealData {
  status: DealStatus;
  position: number;
}

export interface ReorderItem {
  id: string;
  position: number;
}
